import { getProductTypeLabel } from '@finect/front-resources/Products';
export const parseMacrocategoryTemplate = (macrocategory, productType) => ({
  title: macrocategory.template.title.replace(/{{\w+}}/g, match => {
    const key = match.replace(/[{}]/g, '');
    return getProductTypeLabel(productType, key);
  }),
  description: macrocategory.template.description.replace(/{{\w+}}/g, match => {
    const key = match.replace(/[{}]/g, '');
    return getProductTypeLabel(productType, key, 'lowercase' || 'none');
  })
});